import { Package} from './package';
import { ApplicationAnswer} from './application-answer';
import { Child, ChildDetails, onDeserializeChild, onSerializeChild} from './child';
import { PrimaryContactDetails, onDeserializePrimaryContactDetails, onSerializePrimaryContactDetails} from './primary-contact-details';
import { ContactDetails, onDeserializeContactDetails, onSerializeContactDetails} from './contact-details';
import { CareType } from './care-type';
import moment from 'moment';

export interface NewApplicationCommand {
    applicationId: string;
    startAt: moment.Moment;
    careType: CareType;
    schoolId?: string;
    preferredLocations?: string[];
    packages?: Package[];
    answers?: ApplicationAnswer[];
    remarks?: string;
    child?: ChildDetails;
    primaryContact?: PrimaryContactDetails;
    partner?: ContactDetails;
}

export function onDeserializeNewApplicationCommand(data: NewApplicationCommand): NewApplicationCommand {
    if (data == null) {
        return data;
    }

    if (data.startAt != null) {
        data.startAt = moment(data.startAt);
    }
    if (data.child != null) {
        data.child = onDeserializeChild(data.child);
    }
    if (data.primaryContact != null) {
        data.primaryContact = onDeserializePrimaryContactDetails(data.primaryContact);
    }
    if (data.partner != null) {
        data.partner = onDeserializeContactDetails(data.partner);
    }

    return data;
}

export function onSerializeNewApplicationCommand(data: NewApplicationCommand): NewApplicationCommand {
    if (data == null) {
        return data;
    }

    const serialized = { ...data };

    serialized.startAt = data.startAt?.format('YYYY-MM-DD') as unknown as moment.Moment;
    serialized.child = onSerializeChild(data.child);
    serialized.primaryContact = onSerializePrimaryContactDetails(data.primaryContact);
    serialized.partner = onSerializeContactDetails(data.partner);

    return serialized;
}
